import { render, staticRenderFns } from "./TraxAccountUserEditAvatarCard.vue?vue&type=template&id=a43c927c"
import script from "./TraxAccountUserEditAvatarCard.vue?vue&type=script&lang=js"
export * from "./TraxAccountUserEditAvatarCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports